import { useEffect, useState } from "react";

export function useFooterOffset(baseBottom = 20) {
  const [offset, setOffset] = useState(baseBottom);

  useEffect(() => {
    const footer = document.querySelector("footer");
    if (!footer) return;

    const update = () => {
      const rect = footer.getBoundingClientRect();
      const intrusion = Math.max(0, window.innerHeight - rect.top);
      setOffset(baseBottom + intrusion);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [baseBottom]);

  return offset;
}
